import { FindifyTopBarOverlay } from "../../genericPages/components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../../genericPages/components/FindifySimpleHeader";
import { PlaceText } from "../../genericPages/components/PlaceText";
import { getApiFromModule } from "../../genericPages/helpers/GetContentsByModule";
import { Pressable, ScrollView, Share, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import { DefaultShadow, IconShadow } from "../../genericPages/helpers/DefaultShadows";
import { BasePage } from "../../genericPages/helpers/BasePage";
import { BaseFindifyList } from "../../genericPages/components/FindifyList";
import { getTranslatedString } from "../../genericPages/helpers/FindifyTranslatedString";
import { getFeaturedImageUrl, getUniqueDays, makeDateString } from "@/layouts/genericPages/helpers/DetailsHelpers";



export const SchedulePage = ({ navigation }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [events, setEvents] = useState<any[]>([]);
    const [availableDays, setAvailableDays] = useState<any[]>([]);
    const [selectedDayEvents, setSelectedDayEvents] = useState<any[]>([]);
    const [selectedDate, setSelectedDate] = useState<any>(null);
    const [sameYearDates, setSameYearDates] = useState(true);
    const { t } = useTranslation();
    const weekdays = [t('base.day.sunday'), t('base.day.monday'), t('base.day.tuesday'), t('base.day.wednesday'), t('base.day.thursday'), t('base.day.friday'), t('base.day.saturday')];
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);

    useEffect(() => {
        getApiFromModule('events', findifyDataContext)?.getList(0, 200, null, null, { orderby: JSON.stringify({ start_date: "ASC" }) }).then((res) => {
            const evs = res.results;
            setEvents(evs);
            const avDays = getUniqueDays(evs, setSameYearDates);
            setAvailableDays(avDays);
            setSelectedDate(avDays[0]);
        });

        setActionsList([{
            icon: 'share-outline',
            action: async () => {
                const result = await Share.share({
                    title: t('modules.content_types.events') + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                    message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=events`,
                }, {
                    dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                });
            }
        }]);
    }, [])

    useEffect(() => {
        if (selectedDate) {
            const evs = events.filter((e: any) => e.start_date.startsWith(selectedDate));
            setSelectedDayEvents(evs);
        }
    }, [selectedDate])


    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <View
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
            }}>
            <FindifySimpleHeader
                navigation={navigation}
                title={t('modules.schedule')}
                actions={actionsList}
            />
            <View style={[styles.dateZone, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
                <ScrollView
                    bounces={false}
                    showsHorizontalScrollIndicator={false}
                    showsVerticalScrollIndicator={false}
                    horizontal={true}
                    contentContainerStyle={{
                        minWidth: '100%',
                        width: '100%',
                    }}
                >
                    <View
                        style={[
                            {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                minWidth: '100%',
                                width: '100%',
                                gap: 4,
                            },
                        ]}
                    >
                        {availableDays.length > 0 &&
                            availableDays.map((day: any, index: any) => {
                                const date = new Date(day);
                                return (<Pressable onPress={() => setSelectedDate(day)}>
                                    <View style={{
                                        backgroundColor: selectedDate === day ? PlaceColors(findifyDataContext).text.withAlpha(80) : 'transparent',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: 4,
                                        gap: 4,
                                        alignItems: 'center'
                                    }}>
                                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), textTransform: 'capitalize', fontWeight: 'bold' }}>{weekdays[date.getDay()]}</PlaceText>
                                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{date.toLocaleDateString(undefined, { day: '2-digit', month: 'numeric', year: sameYearDates ? undefined : 'numeric' })}</PlaceText>
                                    </View>
                                </Pressable>);
                            })
                        }
                    </View>
                </ScrollView>
            </View>
            <View style={styles.bottomBox} >
                <BaseFindifyList
                    enableGrid={true}
                    items={selectedDayEvents.map((event: any) => {
                        const dateStart = new Date(event?.start_date);
                        const dateEnd = new Date(event?.end_date);

                        const dateString = makeDateString(dateStart) + ' - ' + makeDateString(dateEnd);

                        return {
                            id: event.event_id,
                            image: getFeaturedImageUrl(event),
                            title: getTranslatedString(event.name, findifyDataContext),
                            resume: getTranslatedString(event.resume, findifyDataContext),
                            date: dateString,
                            onPress: () => {
                                navigation.push('PlaceContentDetails', {
                                    module: 'events',
                                    event_id: event.event_id,
                                    page_slug: event.page_slug
                                })
                            }
                        }
                    })}
                    keyExtractor={(item: any, index: any) => index.toString()}
                    selectLabel={t('list.read_more')}
                    actions={undefined} />
            </View>
        </View >
    </BasePage>
};

const styles = StyleSheet.create({
    topNav: {},
    dateZone: {
        ...DefaultShadow,
        width: '100%',

    },
    bottomBox: {
        flex: 1,
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
